// トレーニング履歴（月次）・比較用.
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { JS_VOID } from '../../utils/commonUtil';
import { MDate } from '../../utils/dateUtil';
import { MonthlyCountData } from '../../utils/MonthlyCountData';
import * as TrainingConst from '../../constants/Training';
import { TrainingMenu, TypeVariables } from '../../constants/Training';
import * as Enumerable from 'linq';

// テーブルのprops
interface TableProps extends React.Props<{}> {
  // 0~3のタイプ.
  // history_monthly_tables, history_monthly_date_tablesのインデックスにも使用する.
  myNo: number;

  // 日数.
  historyMonthlyDateTables: any[];

  // 月間テーブル履歴.
  historyMonthlyTables: any[];

  // trueのデータ数.
  numOfTrueDate: number;

  // トレーニング名.
  trainingMenus: TrainingMenu[];

  // 種類.
  type: TrainingConst.TYPE;
}

// 各テーブル生成用.
class Table extends React.Component<TableProps, {}> {
  // 各テーブル用定数.
  typeVariables: TypeVariables[] = [
    {comp: 0, prefix: '1st'},
    {comp: 4, prefix: '2nd'},
    {comp: 8, prefix: '3rd'},
    {comp: 12, prefix: '4th'},
    {comp: 16, prefix: '5th'},
    {comp: 20, prefix: '6th'},
    {comp: 24, prefix: '7th'},
    {comp: 28, prefix: '8th'},
  ];

  componentWillMount() {
    // do something
  }

  render() {
    // history_monthly_tablesなどのインデックスにも使用する.
    const myNo: number = this.props.myNo;

    // 比較用数.
    const comp: number = this.typeVariables[this.props.myNo].comp;

    // key用prefix.
    const prefix: string = this.typeVariables[myNo].prefix;

    if ((this.props.numOfTrueDate > comp) === false) {
      return (null);
    }

    return (
      <table className="tblStyle02">
        <colgroup>
          <col/>
          <col span={4} />
        </colgroup>
        <tbody>
          {this.props.historyMonthlyTables[myNo].map((history: number[], index: number) => {
            // ADLでのスキップ.
            // x 105(101 + 4): 更衣着脱衣(上半身).
            // x 106(101 + 5): 更衣着脱衣(靴下).
            if (this.props.type === TrainingConst.TYPE.ADL && TrainingConst.SKIP_ADL_IDX.indexOf(index) >= 0) {
              return;
            }

            return <tr key={index}>
            {this.props.trainingMenus.map((trainingMenu: TrainingMenu, i: number) => {
              // 1を引いてるのはロコモのidが1開始.
              if (this.props.type === TrainingConst.TYPE.Locomo && trainingMenu.id - 1 === index
                // ADL101開始.
                || this.props.type === TrainingConst.TYPE.ADL && trainingMenu.id - 101 === index) {
                const key = `${prefix}TableHeader${i}`;
                return <th key={key} scope="row">
                {trainingMenu.name}
                </th>;
              }

              // 該当しないときはパス
              return;
            })}
            {history.map((data: number, i: number) => {
              const key = `${prefix}CompareTableBody${i}`;
              if (data > 0) {
                return <td key={key}><p>{data}回</p></td>;
              } else {
                return <td key={key}><p>- </p></td>;
              }
            })}
            </tr>;
          })}
          <tr>
            <th>&nbsp;</th>
            {this.props.historyMonthlyDateTables[myNo].map((date: number, i: number) => {
              const key = `${prefix}CompareTableDateList${i}`;
              return <td key={key}>{date}日</td>;
            })}
          </tr>
        </tbody>
      </table>
    );
  }
}

// レポート props.
interface ReportProps extends React.Props<{}> {
  isStartTerm: boolean;
  mDate: MDate;
  userId: string;
  // start or end.
  className: string;
  trainingMenus: TrainingMenu[];

  history: any;
  type: TrainingConst.TYPE;
}

// レポート(endReport, startReport共通).
export class Report extends React.Component<ReportProps, {}> {
  mDate: MDate;
  yearSelected: string;
  monthSelected: string;

  static get contextTypes() {
    // 親コンポーネントと橋渡しするcontext.
    return {
      // 左右.
      callbackParent: PropTypes.func,
      // ステート変更.
      changeState: PropTypes.func,
    };
  }

  componentWillMount() {
    this.mDate = this.props.mDate;
    this.refresh();
  }

  componentWillReceiveProps() {
    // propsが変わった時に変化.
    // これがないと、日次側で年月に変更があってもこちらが反映されない.
    this.mDate = this.props.mDate;
    this.refresh();
  }

  // 終了をクリックしたときの処理.
  toFinishCompare = (userId: string) => {
    this.context.changeState(TrainingConst.DETAIL_STATE);
  }

  // 左をクリックしたときの処理.
  minusMonthly = (yearSelected: string, monthSelected: string) => {
    // 先月.
    this.mDate.setPreMonth();
    this.refresh();

    // 親contextのメソッド.
    this.context.callbackParent(this.props.isStartTerm, this.mDate.yearmonth);
  }

  // 右をクリックしたときの処理.
  plusMonthly = (yearSelected: string, monthSelected: string) => {
    // 次の月.
    this.mDate.setNextMonth();
    this.refresh();

    // 親contextのメソッド.
    this.context.callbackParent(this.props.isStartTerm, this.mDate.yearmonth);
  }

  // year, monthの更新.
  refresh = () => {
    this.yearSelected = this.mDate.year;
    this.monthSelected = this.mDate.month;

    this.setState({
      yearmonth: this.mDate.yearmonth
    });
  }

  render() {
    const monthlyCountData: MonthlyCountData = new MonthlyCountData(this.props.type);

    // データ有無表示用.
    const dataSize: number = monthlyCountData.dataSize(this.props.history);

    // 配列にresponseデータを格納.
    monthlyCountData.insertData(this.props.history);

    // 日付に記録があるかどうか.
    const historyDateFlag = monthlyCountData.dateFlag;

    // 表示用に、テーブルを最大8つ用意して、配列に格納したresponseデータを格納していく.
    const NUM_TABLES = 8;
    let numRows = 0;

    if (this.props.type === TrainingConst.TYPE.Locomo) {
      // 項目数.
      numRows = TrainingConst.MAX_LOCOMO_CNT;
    } else if (this.props.type === TrainingConst.TYPE.ADL) {
      // 項目数.
      numRows = TrainingConst.MAX_ADL_CNT;
    }

    // 列の数(詳細のときのサイズは9だが、比較の時は4).
    const NUM_COLS = 4;
    const mData = monthlyCountData.divideHistoryMonthTables(
      historyDateFlag, monthlyCountData.historyTable, numRows, NUM_COLS, NUM_TABLES);

    const historyMonthlyTables: number[][][] = [];
    const historyMonthlyDateTables: number[][] = [];

    const numOfTrueDate = mData[0].num_td;

    // 配列分割分.
    for (let i = 0; i < NUM_TABLES; i++) {
      historyMonthlyTables[i] = mData[i].h_month;
      historyMonthlyDateTables[i] = mData[i].h_month_date;
    }

    return (
      <div className={this.props.className}>
        <div className="calendarHeader">
          <div className="dateArea">
            <div className="date">
              {this.yearSelected}<span className="year">年</span>
              {this.monthSelected}<span>月</span>
            </div>
            <div className="btn left">
              <a href={JS_VOID} onClick={event => this.minusMonthly(this.yearSelected, this.monthSelected)} />
            </div>
            <div className="btn right">
              <a href={JS_VOID} onClick={event => this.plusMonthly(this.yearSelected, this.monthSelected)} />
            </div>
          </div>
          { (this.props.isStartTerm) ?
          <div className="btnStyle05 mini">
            <a onClick={event => this.toFinishCompare(this.props.userId)}>終了</a>
          </div> : (null)
          }
        </div>
        { // データ数でのif
        (() => {
          if (dataSize === 0) {
            return <div><p>この月はデータがありません。</p></div>;
          } else if (dataSize === -1) {
            return <div><p>読み込み中</p></div>;
          } else if (dataSize === -2) {
            // actions/MoffAPIのmonthlyData, startData, endDataをnullにしてtest.
            return <div><p>データ取得に失敗した可能性があります。再読込してください。</p></div>;
          } else {
            return<div>
              {
                // 1st to 8th.
                Enumerable.range(0, 7)
                  .select<JSX.Element>(
                    (i) => {
                      return <Table
                        key={`ReportTable${i}`}
                        type={this.props.type}
                        myNo={i}
                        historyMonthlyDateTables={historyMonthlyDateTables}
                        historyMonthlyTables={historyMonthlyTables}
                        numOfTrueDate={numOfTrueDate}
                        trainingMenus={this.props.trainingMenus}
                      />;
                    }
                  ).toArray()
              }
            </div>;
          }
        })()
        }
      </div>
    );
  }
}

// トレーニング履歴（月次）props.
interface MonthlyHistoryCompareProps extends React.Props<{}> {
  userId: string;
  trainingMenus: TrainingMenu[];

  // データ.
  startData: any;
  endData: any;

  // 日付.
  startMDate: MDate;
  newMDate: MDate;

  type: TrainingConst.TYPE;
}

/**
 * トレーニング履歴（月次）.
 *
 * @export
 * @class MonthlyHistoryCompare
 * @extends {React.Component<MonthlyHistoryCompareProps, {}>}
 */
export default class MonthlyHistoryCompare extends React.Component<MonthlyHistoryCompareProps, {}> {
  userId: string;
  startMDate: MDate;
  endMDate: MDate;
  isChange: boolean;

  static get contextTypes() {
    // 親のLocomoCompareコンポーネントと橋渡しするcontext.
    return {callbackParent: PropTypes.func};
  }

  componentWillMount() {
    this.userId = this.props.userId;

    // ここは左、右ボタンの際も呼ばれる.
    this.startMDate = this.props.startMDate;
    this.endMDate = this.props.newMDate;
  }

  render() {
    return (
      <section id="sec02">
        <h2 className="ttlStyle01">トレーニング履歴（月次）</h2>
        <div className="inner">
          <Report
            key={'startReport'}
            isStartTerm={true}
            userId={this.userId}
            mDate={this.startMDate}
            className="startReport"
            trainingMenus={this.props.trainingMenus}
            history={this.props.startData}
            type={this.props.type}
          />
          <Report 
            key={'endReport'}
            isStartTerm={false}
            userId={this.userId}
            mDate={this.endMDate}
            className="endReport"
            trainingMenus={this.props.trainingMenus}
            history={this.props.endData}
            type={this.props.type}
          /> 
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/MonthlyHistoryCompare.tsx